import { Icon } from '@iconify/react';
import { useNavigate, useLocation } from 'react-router-dom';
import * as routes from '../../../Routing/routes';

const tabs = [
    { id: 'categories', title: 'Categories',       icon: 'mdi:shape',              path: routes.SOCIETY_PORTAL_VENDOR_SETTINGS_CATEGORIES },
    { id: 'billing',    title: 'Billing Settings', icon: 'mdi:file-document-edit', path: routes.SOCIETY_PORTAL_VENDOR_SETTINGS_BILLING },
];

const VendorSettingLayout = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const currentPath = location.pathname.replace(routes.SOCIETY_PORTAL, '');

    return (
        <>
            {/* Header */}
            <div className="tw-flex tw-items-center tw-justify-between tw-mb-4">
                <div>
                    <h1 className="tw-text-lg tw-font-semibold tw-text-gray-800">Vendor Settings</h1>
                    <p className="tw-text-xs tw-text-gray-500">Configure vendor management settings</p>
                </div>
            </div>

            {/* Tabs */}
            <div className="tw-bg-white tw-rounded-lg tw-shadow-sm tw-border tw-border-gray-100 tw-mb-4 tw-inline-flex tw-p-1">
                {tabs.map(tab => (
                    <button
                        key={tab.id}
                        onClick={() => !tab.disabled && navigate(routes.SOCIETY_PORTAL + tab.path)}
                        disabled={tab.disabled}
                        className={`tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-rounded-md tw-text-sm tw-font-medium tw-transition-all ${tab.disabled ? 'tw-text-gray-300 tw-cursor-not-allowed' : currentPath === tab.path ? 'tw-bg-blue-600 tw-text-white tw-shadow-sm' : 'tw-text-gray-600 hover:tw-bg-gray-50'}`}
                    >
                        <Icon icon={tab.icon} className="tw-text-base" />
                        <span>{tab.title}</span>
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            {children}
        </>
    );
};

export default VendorSettingLayout;
